import { render, staticRenderFns } from "./AdyenPayments.vue?vue&type=template&id=56132021"
import script from "./AdyenPayments.vue?vue&type=script&lang=js"
export * from "./AdyenPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports